import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-the-template-h" }
const _hoisted_2 = { class: "p-the-template-h__header" }
const _hoisted_3 = { class: "p-the-template-h__body" }
const _hoisted_4 = { class: "p-the-template-h__body__inner" }
const _hoisted_5 = {
  key: 0,
  class: "p-the-template-h__body__header"
}
const _hoisted_6 = { class: "p-the-template-h__body__heading" }
const _hoisted_7 = {
  key: 0,
  class: "p-the-template-h__body__header__label"
}
const _hoisted_8 = { class: "p-the-template-h__body__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonHeading = _resolveComponent("CommonHeading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CommonHeading, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.heading), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.$slots['title'])
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("h2", _hoisted_6, [
                _renderSlot(_ctx.$slots, "title", {}, undefined, true)
              ]),
              (_ctx.$slots['header-label'])
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _renderSlot(_ctx.$slots, "header-label", {}, undefined, true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _renderSlot(_ctx.$slots, "contents", {}, undefined, true)
        ])
      ])
    ])
  ]))
}